module.exports = __webpack_public_path__ + "img/logo500.178f6177.svg";